import React, { useEffect, useRef, InputHTMLAttributes } from "react";
import { useField } from "@unform/core";
import { InputElement, InputContainer, InputLabel, InputError } from "./styles";

interface IProps extends InputHTMLAttributes<any> {
    name: string;
    label?: string;
}

const Input = ({ name, label, ...rest }: IProps) => {
    const inputRef = useRef(null);
    const { fieldName, defaultValue = "", registerField, error } = useField(
        name
    );

    console.log("error", error);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: "value",
        });
    }, [fieldName, registerField]);

    return (
        <InputContainer>
            {!!label && <InputLabel htmlFor={name}>{label}</InputLabel>}
            <InputElement
                ref={inputRef}
                defaultValue={defaultValue}
                name={name}
                id={name}
                error={!!error}
                {...rest}
            />
            {!!error && <InputError>{error}</InputError>}
        </InputContainer>
    );
};

export default React.memo(Input);
